import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IEnrolledStudentByMonth } from "../../../models/statistics.model";
import Chart from "react-apexcharts";

interface IProps {
  data: IEnrolledStudentByMonth[]|undefined;
}

const ChartContainer: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const getCampusData = (monthData: any) => {
    const campusData: number[] = [];
    for (let i = 1; i <= 12; i++) {
      const month = monthData.find((item: any) => Number(item.monthNameCode) === i);
      campusData.push(month?.reCount || 0);
    }

    return campusData;
  }

  return (
    <div className="flex flex-justify-center">
      <div style={{ width: '100%', height: '70vh', marginTop: 20 }}>
        <Chart
          type="line"
          height="100%"
          options={{
            chart: {
              toolbar: { show: false }
            },
            xaxis: {
              categories: [...Array(12)].map((el, index) => `${index + 1}${t('statistics.refund.option1')}`),
            }
          }}
          series={data?.map(item => {
            return {
              name: item.campusKorName,
              data: getCampusData(item.monthInfo),
            };
          })}
        />
      </div>
    </div>
  );
}

export default ChartContainer;
